import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

import Icon from '../components/Icon';

import '../styles/note.css';

export default class NoteController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noteId: (props.match) ? props.match.params.noteId : null,
      content: props.content,
      type: props.type || 'idea',
      source: props.source,
      title: props.title,
      postId: props.postId
    };
    this.delete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    if (this.state.noteId) {
      this.loadNote();
    }
  }

  handleDelete() {
    if (this.state.noteId) {
      fetch('/api/note/' + this.state.noteId, {
        credentials: 'same-origin',
        method: 'DELETE'});
    }
  }

  loadNote() {
    const that = this;
    fetch('/api/note/' + this.state.noteId, {credentials: 'same-origin', method: 'GET'})
      .then((res) => {
        res.json().then((note) => {
          that.setState({
            content: note.content,
            source: note.source,
            title: note.title,
            postId: note.post_id,
            type: note.type
          });
        });
      });
  }

  save() {
    const that = this;
    const url = (this.state.noteId) ? `/api/note/${this.state.noteId}` : '/api/note';
    const options = {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'POST',
      body: JSON.stringify({
        content: this.state.content,
        source: this.state.source,
        title: this.state.title,
        type: this.state.type,
        post_id: this.state.postId
      })
    };
    fetch(url, options).then((res) => {
      if (res.status === 201) {
        res.json().then((note) => that.props.onSave(note));
      }
    });
  }

  setContent(content) {
    this.setState({content});
  }

  setSource(source) {
    this.setState({source});
  }

  setTitle(title) {
    this.setState({title});
  }

  setType(type) {
    this.setState({type});
  }

  getForm() {
    const inputs = [
      <input type='text' onChange={(e) => this.setTitle(e.target.value)} placeholder='title' />];

    if (this.state.type === 'quote' || this.state.type === 'idea') {
      inputs.push(<TextareaAutosize
        onChange={(e) => this.setContent(e.target.value)}
        rows={3}
        value={this.state.content} />);
    }
    inputs.push(
      <input type='text' onChange={(e) => this.setSource(e.target.value)} placeholder='source' />);
    return inputs;
  }

  render() {
    if (this.state.loading) {
      return <div>Loading note for editing..</div>;
    }

    return (<div className='note-form'>
      <ul className='note-type-selector'>
        <li className={this.state.type === 'idea' ? 'active' : ''} onClick={(e) => this.setType('idea')}><Icon name='exclamation-sign' /></li>
        <li className={this.state.type === 'quote' ? 'active' : ''} onClick={(e) => this.setType('quote')}><span className='quote-icon'>"</span></li>
        <li className={this.state.type === 'link' ? 'active' : ''} onClick={(e) => this.setType('link')}><Icon name='link' /></li>
      </ul>
      <div className='note-input'>
        {this.getForm()}
      </div>
      <button onClick={(e) => this.save()}>
        <span className='glyphicon glyphicon-floppy-disk'/>
      </button>
      <button className='btn-danger' onClick={this.delete}>Delete</button>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NoteController.js